import { router, useLocalSearchParams } from 'expo-router';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { useGetNonProfitInsights, useGetNonProfitLightRatingQuestions } from '@/api/hooks/nonProfitOrgHooks';
import BrandedButton from '@/components/buttons/BrandedButton';
import DotsLoader from '@/components/DotsLoader';
import FormWrapper from '@/components/forms/FormWrapper';
import ExplanationCard from '@/components/lightRating/ExplanationCard';
import LoginHeader from '@/components/LoginHeader';
import Text from '@/components/Text';
import { NpoOnboardingRoutes } from '@/constants/enums/NpoOnboardingRoutes';
import { SIGN_IN_BUTTON_BOTTOM } from '@/constants/layout';
import { useAuth } from '@/contexts/authContext';
import { useNpoLoginScreenState } from '@/contexts/npoLoginScreenStateContext';
import { i18n } from '@/utils/i18n';

const Intro = () => {
  const { whereToGoAfterIntro } = useLocalSearchParams<{
    whereToGoAfterIntro: NpoOnboardingRoutes;
  }>();
  const { state: authState } = useAuth();
  const { setInitialNpoData } = useNpoLoginScreenState();
  // Fetching questions for last page of onboarding
  const { isFetching: fetchingQuestions } = useGetNonProfitLightRatingQuestions();
  const { data, isFetching } = useGetNonProfitInsights({ id: authState.signUpData?.loginEmail?.npoId ?? '' });

  return (
    <FormWrapper keyboardVerticalOffset={0}>
      <SafeAreaView style={styles.content}>
        <LoginHeader />
        <View style={styles.container}>
          {isFetching || fetchingQuestions ? (
            <View style={styles.loader}>
              <DotsLoader />
            </View>
          ) : (
            <>
              <View style={styles.body}>
                <Text fontWeight="700" style={styles.title}>
                  {i18n.t('sign_in.nonProfit.intro.title')}
                </Text>
                <Text>{i18n.t('sign_in.nonProfit.intro.subtitle')}</Text>
                <ExplanationCard />
              </View>

              <BrandedButton
                style={styles.button}
                onPress={() => {
                  setInitialNpoData(JSON.stringify(data));
                  router.navigate({
                    pathname: '/login/nonProfit/startSetup',
                    params: {
                      whereToGoAfterIntro
                    }
                  });
                }}>
                {i18n.t('sign_in.nonProfit.intro.start')}
              </BrandedButton>
            </>
          )}
        </View>
      </SafeAreaView>
    </FormWrapper>
  );
};

const styles = StyleSheet.create({
  content: {
    flex: 1
  },

  container: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between'
  },

  loader: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },

  body: {
    flexDirection: 'column',
    gap: 25
  },

  title: {
    fontSize: 22,
    color: 'black'
  },

  button: {
    marginBottom: SIGN_IN_BUTTON_BOTTOM
  }
});

export default Intro;
